import QRCode from 'qrcode';

const DEFAULT_WIDTH = 300;

export async function generateQrDataUrl(text: string, width = DEFAULT_WIDTH): Promise<string> {
  return QRCode.toDataURL(text, { width });
}
